import { instance as axios, setJwtToken } from "../../config/axiosInstance";

// ---------------------User-listing--------------------------
export const userListApis = async (data) => {
  const endPoint =
    `user/list` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
// ------------------------- User remove-----------
export const userRemoveApi = async (id) => {
  const endPoint = `user/delete/${id}`;
  return await axios.delete(endPoint, setJwtToken());
};
// ------------------------user Detail---------------------
export const userDetailApi = async (id) => {
  const endPoint = `user/detail/${id}`;
  return await axios.get(endPoint, setJwtToken());
};
// --------------------------User status change------------------
export const userStatusChangeApi = async (data) => {
  const endPoint = `user/change_status`;
  return await axios.put(endPoint, data, setJwtToken());
};

export const userPostDetailApi = async (id) => {
  const endPoint = `user/posts/${id}`;
  return await axios.get(endPoint, setJwtToken());
};

export const userQuestionDetailApi = async (id) => {
  const endPoint = `user/onboarding_question/${id}`;
  return await axios.get(endPoint, setJwtToken());
};

export const userFollowerDetailApi = async (data) => {
  const endPoint =
    `user/follow_following` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
// -- toggle subscription

// --------------------------User status change------------------
export const userToggleSubscription = async (data) => {
  const endPoint = `user/premium_status/${data.userId}`;
  return await axios.put(endPoint, data, setJwtToken());
};
